import { render, staticRenderFns } from "./ChapterDetail.vue?vue&type=template&id=b58ad0ba&scoped=true&"
import script from "./ChapterDetail.vue?vue&type=script&lang=js&"
export * from "./ChapterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58ad0ba",
  null
  
)

export default component.exports